<template>
	<!-- 机构标的 -->
	<div>
		<ul class="organization_center_title">
			<li>即将开拍</li>
			<li>正在进行</li>
			<li>中标</li>
			<li>流拍</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'OrganizationBiaodi',
	inject: ['reload'],
	data (){
		return{
			token: localStorage.getItem('apiToken'),
			OrganizationBiaodiData: []
		}
	},
	created(){
		
	},
	watch:{
		
	},
	mounted(){

	},
	computed: {

	},
	methods: {
		
	}
}
</script>